export const Logo = ({ dark = false, className = "h-10" }) => (
  <img
    src="/logos/group.png"
    alt="Altalib Group — مجموعة آل طالب"
    data-testid="altalib-logo"
    className={`w-auto object-contain ${className} ${dark ? "invert" : ""}`}
  />
);
